// extracted by mini-css-extract-plugin
module.exports = {"DashboardSkeleton":"DashboardSkeleton_DashboardSkeleton__180gq","Item":"DashboardSkeleton_Item__342rF"};